export interface ILanguage {
  name: string
  code: string
  label: string
}

const languagesInOrder: ILanguage[] = [
  { name: 'English', code: 'en', label: 'EN' },
  { name: 'Deutch', code: 'de', label: 'DE' },
  { name: 'Spanish', code: 'es', label: 'ES' },
  { name: 'French', code: 'fr', label: 'FR' },
  { name: 'Portugese (Brazilian)', code: 'pt-BR', label: 'PT' },
]

const lngCodes = languagesInOrder.map((lng) => lng.code)
const defaultLng = languagesInOrder[0]

module.exports = {
  lngCodes,
  defaultLng,
  languages: languagesInOrder,
}
